export const RELATED_NEWS_VIEW = {
    View_Half: 0,
    View_Grid: 1,
    View_Full: 2,
    View_Mobile: 3,
};
